/*
* Hidden Input FE functionality
*/
class Hidden {
    // Constructor
    constructor(element, baseUseClass) {
        this.init = this.init.bind(this);
        this.baseUseClass = baseUseClass;
        this.init(element);
    }

    init(element) {
        const sessionData = JSON.parse(this.baseUseClass.readFromSessionStorage('sessionData'));
        if (!sessionData) return;
        $(element).each((index, el) => {
            const input = $(el).find('input[type="hidden"]');
            if (
                $(el).data().prefillFromSessionStorage
                && $(el).data().prefill.length > 0
                && sessionData !== undefined
                && sessionData !== null
                && sessionData[$(el).data().prefill].length > 0
                && sessionData[$(el).data().prefill] !== 'unknown'
            ) {
                $(input).val(sessionData[$(el).data().prefill]);
            }
        });
    }
}

export default Hidden;
